// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_Vtv","colBig":"styles_colBig__1lRFi","colSmall":"styles_colSmall__DsBD0"};